import { useEffect } from "react"
import { GlobalMachineContext } from "../../../study-plans/pages/StudyPlansInit/StudyPlansInit"
import { getPlanRefIdByRefScope } from "../../../study-plans/helpers"

export const useCurrentPlanRefScope = () => {
  const { send } = GlobalMachineContext.useActorRef()
  const { selectedEntity, isStudentPlan, selfRefScope } =
    GlobalMachineContext.useSelector(state => ({
      selectedEntity: state.context.selectedEntity,
      isStudentPlan: state.context.isStudentPlan,
      selfRefScope: state.context.selfRefScope
    }))

  useEffect(() => {
    if (!selectedEntity && selfRefScope) {
      send({
        type: "SET_PLAN_REF_SCOPE",
        scope: selfRefScope.scope,
        targetRefId: getPlanRefIdByRefScope(selfRefScope)
      })
      return
    }

    if (!selectedEntity) return

    send({
      type: "SET_PLAN_REF_SCOPE",
      scope: isStudentPlan ? "STUDENT" : "CLASS",
      targetRefId: selectedEntity.entityId
    })
  }, [selectedEntity, isStudentPlan, selfRefScope])
}
